import { useContext, useEffect } from "react";
import ModelElements from "../ModelElements";
import { ProductModelProps } from "../ModelViewerProduct";
import ProductTextureContext from "../_contexts/ProductTextureContext";
import useGLB from "../_hooks/useGLB";

export default function DrapedKimono(props: ProductModelProps) {
    const url = new URL('@resources/3d-models/glb/draped-kimono.glb', import.meta.url);
    const model = useGLB(url)
    const elements = model.scene.children
    const [productTexture] = useContext(ProductTextureContext)

    useEffect(() => {
        if(!elements) return

        // Enable see-through for inner material
        if(elements[1]?.material) elements[0].material.side = 2
        if(elements[0]?.material) {
            elements[0].material.transparent = true
            elements[0].material.opacity = 0.8
        }
    }, [elements])

    // Apply lab texture
    useEffect(() => {
        if(!elements || !elements[1]?.material) return

        elements[1].material.map = productTexture
        elements[1].material.map.flipY = false
        elements[1].material.map.needsUpdate = true
    }, [productTexture, elements])
    
    return <ModelElements scene={model.scene}/>
}